import { loginModule } from "../login-module";


function unregisterController($scope) {
    var ctrl = this;

    ctrl.$onInit = async function () {
       
    }

}

loginModule.component('unregister', {
    template: require('./unregister.component.html'),
    controller: ['$scope', unregisterController],

});